import { createEnum } from "@redotech/zod/zod-enum";

export enum PackingMode {
  INDIVIDUAL = "individual",
  CASE_PACK = "case_pack",
  PALLET = "pallet",
  WEIGHT = "weight",
}

export const PackingModeSchema = createEnum(PackingMode, {
  enumName: "PackingMode",
});
